import { BTr } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBTr = createEgBootstrapProxy("EgBTr", BTr);
